import React from 'react';
import { title } from '../config/config';
import SEO, { seoConfig } from '../component/SEO';
import PageShapes from '../component/PageShapes';

const Terms = () => {
  return (

    <>

    <SEO {...seoConfig.terms} />
    <PageShapes />
    <div className="legal-page">
      <header className="legal-header">
        <div className="badge">Community Guidelines</div>
        <h1>Terms of <span>Service</span></h1>
        <p>A fair agreement for a collaborative ecosystem • Last updated: April 07, 2026</p>
      </header>

      <article className="legal-content">
        {/* 1. ACCEPTANCE */}
        <section>
          <h3>1. Acceptance of Terms</h3>
          <p>
            By accessing {title} (an ecosystem under the <strong>TheDC</strong> brand), you agree to be bound by these terms. 
            If you do not agree with any part of these terms, you are prohibited from using the workspace. 
            We provide a platform for validation, not a legal advisory service.
          </p>
        </section>

        {/* 2. INTELLECTUAL PROPERTY */}
        <section>
          <h3>2. Ownership & Intellectual Property</h3>
          <p>
            <strong>Your Ideas are Yours:</strong> We do not claim ownership of the content you forge. 
            Your "Problem Statements" and "Solutions" remain your property.
          </p>
          <ul className="legal-list">
            <li><strong>Public License:</strong> When you post content publicly, you grant other users a non-exclusive license to view, comment, and collaborate on that content.</li>
            <li><strong>TheDC Assets:</strong> Our logo, 3D UI elements, and "{title}" branding are protected assets of <strong>TheDC</strong>. You may not replicate our design system for external use without permission.</li>
          </ul>
        </section>

        {/* 3. USER ACCOUNT RESPONSIBILITY */}
        <section>
          <h3>3. Account Security</h3>
          <p>
            Since you log in via Google OAuth, you are responsible for maintaining the security of 
            your Google account. Any activity performed under your {title} profile is your responsibility. 
            If you suspect unauthorized access, notify us immediately at our official contact.
          </p>
        </section>

        {/* 4. PROHIBITED CONDUCT */}
        <section>
          <h3>4. The "No-Noise" Policy</h3>
          <p>To keep the ecosystem high-signal, the following behaviors are strictly prohibited:</p>
          <ul className="legal-list">
            <li><strong>Idea Scraping:</strong> Automated harvesting of community ideas for commercial gain.</li>
            <li><strong>Toxic Interactions:</strong> Harassment of Problem Architects or Solution Providers.</li>
            <li><strong>Spam:</strong> Posting repetitive promotional links or "Low-Effort" content that doesn't add value to the validation process.</li>
          </ul>
        </section>

        {/* 5. SERVICE EVOLUTION */}
        <section>
          <h3>5. Platform Stability & Updates</h3>
          <p>
            As an independent project led by <strong>Sunil Sharma</strong>, {title} is in constant evolution. 
            We reserve the right to modify, suspend, or discontinue any feature (like the Bento Grid layout 
            or Collaboration Mode) to improve the overall experience. We are not liable for any data 
            loss resulting from platform updates.
          </p>
        </section>

        {/* 6. LIMITATION OF LIABILITY */}
        <section>
          <h3>6. Disclaimer of Liability</h3>
          <p>
            {title} is provided "As Is." We do not guarantee that every idea forged here will lead 
            to a successful business or that the solutions provided by the community are technically 
            accurate. Use the information at your own risk.
          </p>
        </section>

        {/* 7. TERMINATION */}
        <section>
          <h3>7. Termination of Access</h3>
          <p>
            We reserve the right to terminate your access to the platform without prior notice if 
            we find you in violation of these terms. Our goal is to protect the integrity of the 
            genuine builder community.
          </p>
        </section>

        {/* CONTACT BOX */}
        <section className="contact-box">
          <h3>Legal & Support</h3>
          <p>
            For legal inquiries, dispute resolution, or feedback regarding these terms, 
            please reach out to our team:
          </p>
          <div className="email-highlight">thedc.here@gmail.com</div>
        </section>
      </article>
    </div>

    </>

  );
};

export default Terms;